// @flow

import React, { useContext } from 'react';
import { BreakpointContext, LARGE } from '@core-ui/breakpoint-provider';
// $FlowFixMe
import useCatBreadcrumb from '../../hooks/features/useCatBreadcrumb';
// $FlowFixMe
import useBottomProductBreadcrumbs from '../../hooks/features/useBottomProductBreadcrumbs';
import CategoryBreadcrumbsDivision from './styled/CategoryBreadcrumbsDivision';
import { ProductBreadcrumbs } from '@core-ui/product-breadcrumbs';
// $FlowFixMe
import useBrRedesign from '../../hooks/features/useBRRedesign';

type CategoryBreadcrumbsProps = {
  breadcrumbs: {
    [breadcrumb: string]: {
      name?: string,
      url?: string,
      order?: number,
    },
  },
  showCategorybreadcrumbs: boolean,
};

const CategoryBreadcrumbs = (props: CategoryBreadcrumbsProps) => {
  const { breadcrumbs, showCategorybreadcrumbs } = props;
  const { smallerThan } = useContext(BreakpointContext);
  const brRedesignEnabled = useBrRedesign();
  const bottomProductBreadcrumbsEnabled =
    useBottomProductBreadcrumbs() || brRedesignEnabled;
  const catBreadcrumbEnabled = useCatBreadcrumb();
  const isSmallerThanLargeViewPort = smallerThan(LARGE);
  const breadcrumbsStylePreference = {
    bottomProductBreadcrumbsEnabled,
    isSmallerThanLargeViewPort,
    brRedesignEnabled,
  };
  const checkIsCategoryBreadCrumbEnabled = () =>
    showCategorybreadcrumbs && catBreadcrumbEnabled;
  return (
    checkIsCategoryBreadCrumbEnabled() && (
      <CategoryBreadcrumbsDivision
        breadcrumbsStylePreference={breadcrumbsStylePreference}
      >
        <ProductBreadcrumbs breadcrumbs={breadcrumbs} />
      </CategoryBreadcrumbsDivision>
    )
  );
};

export default CategoryBreadcrumbs;
